<!--
 * @Description: 水泥模板，录入和回显，调整状态
 * @Autor: yjx
 * @Date: 2021-11-16 10:24:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:04:20
-->
<template>
  <div id="template1" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="9"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_06 }}</td>
        <td>车 牌 号</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-date-picker v-model="formData.cell_08.resultValue" :disabled="isViewResult" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" :readonly="isViewResult" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_13 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_14 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td :class="{ bg4: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td>材质证明</td>
        <td :class="formData.cell_17.clsObj" colspan="2">
          <el-select v-model="formData.cell_17.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>颜色对比</td>
        <td :class="formData.cell_18.clsObj" colspan="2">
          <el-select v-model="formData.cell_18.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_18.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td colspan="2">入库温度（℃）</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          <el-input v-model="formData.cell_19.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>加水时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-tooltip class="item" effect="dark" :content="formData.cell_20.resultValue" placement="top">
            <el-date-picker
              v-model="formData.cell_20.resultValue"
              :disabled="isViewResult"
              :editable="false"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间"
              @change="getChanges"
            >
            </el-date-picker>
          </el-tooltip>
        </td>
        <td>初凝测读时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date">
          <el-tooltip class="item" effect="dark" :content="formData.cell_21.resultValue" placement="top">
            <el-date-picker
              v-model="formData.cell_21.resultValue"
              :disabled="isViewResult"
              :editable="false"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间"
              @change="getChanges"
            >
            </el-date-picker>
          </el-tooltip>
        </td>
        <td>终凝测读时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" :title="formData.cell_22.resultValue">
          
          <el-tooltip class="item" effect="dark" :content="formData.cell_22.resultValue" placement="top">
            <el-date-picker v-model="formData.cell_22.resultValue" :disabled="isViewResult" :editable="false" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" @change="getChanges">
          </el-date-picker>
          </el-tooltip>
        </td>
        <td>胶砂加水时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="4">
          <el-time-picker v-model="formData.cell_23.resultValue" :disabled="isViewResult" :editable="false" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" @change="getChanges">
          </el-time-picker>
        </td>
      </tr>
      <tr>
        <td rowspan="2">标准稠度用水量检测</td>
        <td>试样重（g）</td>
        <td>试杆距底板距离（mm）</td>
        <td>标准稠度用水量（ml）</td>
        <td>标准稠度（%）</td>
        <td>初凝时间（min）</td>
        <td>终凝时间（min）</td>
        <td>试验期龄</td>
        <td colspan="2">3天</td>
        <td colspan="2">28天</td>
      </tr>
      <tr>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_24.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_26.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">{{ formData.cell_27.resultValue }}</td>
        <td :class="formData.cell_28.clsObj">
          {{ formData.cell_28.resultValue }}
          <el-tooltip v-if="formData.cell_28.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_28.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="formData.cell_29.clsObj">
          {{ formData.cell_29.resultValue }}
          <el-tooltip v-if="formData.cell_29.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_29.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>强度项目</td>
        <td>检测值</td>
        <td>平均值</td>
        <td>检测值</td>
        <td>平均值</td>
      </tr>
      <tr>
        <td>安定性</td>
        <td :class="formData.cell_52.clsObj" colspan="2">
          <!-- <el-select v-model="formData.cell_52.resultValue" placeholder="请选择">
                        <el-option :value="0" label="试饼法" />
                        <el-option :value="1" label="雷氏夹法" />
                    </el-select> -->
          <el-select v-model="formData.cell_52.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_52.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td :class="formData.cell_30.clsObj" colspan="4">
          <!-- <el-select v-model="formData.cell_30.resultValue" placeholder="请选择">
                        <el-option :value="0" label="合格" />
                        <el-option :value="1" label="不合格" />
                    </el-select> -->
          <el-select v-model="formData.cell_30.resultValue" value-key="id" :readonly="isViewResult">
            <el-option v-for="item in formData.cell_30.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td rowspan="3">抗折强度（Mpa）</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_39.resultValue" placeholder="请输入" :readonly="isViewResult" @change="getMathDeic(39)" />
        </td>
        <td :class="{ bg6: !isViewResult }" rowspan="3">{{ formData.cell_42.resultValue === -1 ? "无效" : formData.cell_42.resultValue }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_53.resultValue" placeholder="请输入" :readonly="isViewResult" @change="getMathDeic(53)" />
        </td>
        <td :class="{ bg6: !isViewResult }" rowspan="3">{{ formData.cell_43.resultValue === -1 ? "无效" : formData.cell_43.resultValue }}</td>
      </tr>
      <tr>
        <td rowspan="4">选检项目</td>
        <td colspan="2">比表面积（m²/kg）</td>
        <td colspan="2">三氧化硫含量（%）</td>
        <td colspan="2">烧矢量（%）</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_40.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_54.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_31.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_32_p04.clsObj" colspan="2" @click="setData('cell_32_')">
          {{ formData.cell_32_p04.resultValue || "请配置" }}
          <el-tooltip v-if="formData.cell_32_p04.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_32_p04.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="formData.cell_33_p04.clsObj" colspan="2" @click="setData('cell_33_')">
          {{ formData.cell_33_p04.resultValue || "请配置" }}
          <el-tooltip v-if="formData.cell_33_p04.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_33_p04.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_41.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_55.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="2">外加剂适用性（净浆流动度）</td>
        <td>初始流动度（mm）</td>
        <td>1h后流动度（mm）</td>
        <td>2h后流动度（mm）</td>
        <td colspan="2">外加剂适用性判断</td>
        <td rowspan="6">抗压强度（Mpa）</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_44.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_50.clsObj" rowspan="6">
          {{ formData.cell_50.resultValue === -1 ? "无效" : formData.cell_50.resultValue }}
          <el-tooltip v-if="formData.cell_50.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_50.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_56.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_51.clsObj" rowspan="6">
          {{ formData.cell_51.resultValue === -1 ? "无效" : formData.cell_51.resultValue }}
          <el-tooltip v-if="formData.cell_51.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_51.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_34.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_35.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_36.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }" colspan="2">{{ formData.cell_37.resultValue }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_45.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_57.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="4">备 注</td>
        <td rowspan="4" colspan="6" class="remark">
          <el-input v-model="formData.cell_38.resultValue" type="textarea" :rows="4" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_46.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_58.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_47.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_59.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_48.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_60.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_49.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td v-if="formData.cell_61" :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_61.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">{{ user.approver.label }}</td>
        <td></td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>

    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

// category：1必检2选检3必填4选填5系统带入值6默认值7快检项目
// type: 1下拉框2区间3输入框
const dataArr = {
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 2, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 2, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 2, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 2, code: "cell_15" },
  cell_16: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },
  cell_17: {
    resultValue: "",
    title: "材质证明",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "齐全且一致" },
      { id: 1, label: "不齐全或不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_18: {
    resultValue: "",
    title: "颜色对比",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "相邻批次一致" },
      { id: 1, label: "相邻批次不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_19: { resultValue: "", title: "入库温度", category: 7, type: 2 },
  cell_20: { resultValue: "", key: "jssj", title: "加水时间", category: 3, type: 2, code: "cell_20" },
  cell_21: { resultValue: "", key: "cncdsj", title: "初凝测读时间", category: 3, type: 2, code: "cell_21" },
  cell_22: { resultValue: "", key: "zncdsj", title: "终凝测读时间", category: 3, type: 2, code: "cell_22" },
  cell_23: { resultValue: "", key: "jsjssj", title: "胶砂加水时间", category: 3, type: 2, code: "cell_23" },
  cell_24: { resultValue: "", key: "syz", title: "试样重", category: 3, type: 2, code: "cell_24", default: "500" },
  cell_25: { resultValue: "", key: "sgjdbjl", title: "试杆据底板距离", category: 3, type: 2, code: "cell_25", default: "6" },
  cell_26: { resultValue: "", key: "bzcdysl", title: "标准稠度用水量", category: 3, type: 2, code: "cell_26" },
  cell_27: { resultValue: "", key: "bzcd", title: "标准稠度", category: 4, type: 2, code: "cell_27" },
  cell_28: { resultValue: "", key: "cnsj", title: "初凝时间", category: 1, type: 2, code: "cell_28" },
  cell_29: { resultValue: "500", key: "znsj", title: "终凝时间", category: 1, type: 2, code: "cell_29" },
  cell_52: {
    resultValue: "",
    key: "sbflsjf",
    title: "安定性检测方法",
    category: 3,
    type: 1,
    code: "cell_52",
    require: true,
    options: [
      { id: 0, label: "试饼法" },
      { id: 1, label: "雷氏夹法" },
    ],
    clsObj: { bg1: true },
  },
  cell_30: {
    resultValue: "",
    key: "adx",
    title: "安定性",
    category: 1,
    type: 1,
    code: "cell_30",
    require: true,
    options: [
      { id: 0, label: "合格" },
      { id: 1, label: "不合格" },
    ],
    clsObj: { bg1: true },
  },
  cell_31: { resultValue: "", key: "bbmj", title: "比表面积", category: 4, type: 2, code: "cell_31" },
  // cell_32:{resultValue: '', key: 'syhlhl', title: '三氧化硫含量', category: 3, type: 2, code: 'cell_32', clsObj: {bg1: true}},
  // cell_33:{resultValue: '', key: 'ssl', title: '烧矢量', category: 3, type: 2, code: 'cell_33', clsObj: {bg2: true}},
  cell_32_p01: { unit: "g", valType: "input", resultValue: "", key: "syhlkggz", title: "空坩埚重", category: 4, type: 2, code: "cell_32_p01" },
  cell_32_p02: { unit: "g", valType: "input", resultValue: "1.0000", key: "syhlsyz", title: "试样重", category: 4, type: 2, code: "cell_32_p02" },
  cell_32_p03: { unit: "g", valType: "input", resultValue: "", key: "syhlzshzz", title: "灼烧后总重", category: 4, type: 2, code: "cell_32_p03" },
  cell_32_p04: { unit: "g", valType: "calc", resultValue: "", key: "syhlhl", title: "三氧化硫含量", category: 4, type: 2, code: "cell_32_p04" },
  cell_33_p01: { unit: "g", valType: "input", resultValue: "", key: "sslkggz", title: "空坩埚重", category: 4, type: 2, code: "cell_33_p01" },
  cell_33_p02: { unit: "g", valType: "input", resultValue: "1.0000", key: "sslsyz", title: "试样重", category: 4, type: 2, code: "cell_33_p02" },
  cell_33_p03: { unit: "g", valType: "input", resultValue: "", key: "sslzhhzz", title: "灼烧后总重", category: 4, type: 2, code: "cell_33_p03" },
  cell_33_p04: { unit: "g", valType: "calc", resultValue: "", key: "ssl", title: "烧矢量", category: 4, type: 2, code: "cell_33_p04" },
  cell_34: { resultValue: "", key: "csldd0", title: "初始流动度", category: 4, type: 2, code: "cell_34" },
  cell_35: { resultValue: "", key: "csldd1", title: "1h后流动度", category: 4, type: 2, code: "cell_35" },
  cell_36: { resultValue: "", key: "csldd2", title: "2h后流动度", category: 4, type: 2, code: "cell_36" },
  cell_38: { resultValue: "", key: "bz", title: "备注", category: 4, type: 2, code: "cell_38" },
  cell_39: { resultValue: "", key: "kzqd3_1", title: "抗折强度", category: 3, type: 2, code: "cell_39" },
  cell_40: { resultValue: "", key: "kzqd3_2", title: "抗折强度", category: 3, type: 2, code: "cell_40" },
  cell_41: { resultValue: "", key: "kzqd3_3", title: "抗折强度", category: 3, type: 2, code: "cell_41" },
  cell_53: { resultValue: "", key: "kzqd28_1", title: "抗折强度", category: 3, type: 2, code: "cell_53" },
  cell_54: { resultValue: "", key: "kzqd28_2", title: "抗折强度", category: 3, type: 2, code: "cell_54" },
  cell_55: { resultValue: "", key: "kzqd28_3", title: "抗折强度", category: 3, type: 2, code: "cell_55" },
  cell_44: { resultValue: "", key: "kyqd3_1", title: "抗压强度", category: 3, type: 2, code: "cell_44" },
  cell_45: { resultValue: "", key: "kyqd3_2", title: "抗压强度", category: 3, type: 2, code: "cell_45" },
  cell_46: { resultValue: "", key: "kyqd3_3", title: "抗压强度", category: 3, type: 2, code: "cell_46" },
  cell_47: { resultValue: "", key: "kyqd3_4", title: "抗压强度", category: 3, type: 2, code: "cell_47" },
  cell_48: { resultValue: "", key: "kyqd3_5", title: "抗压强度", category: 3, type: 2, code: "cell_48" },
  cell_49: { resultValue: "", key: "kyqd3_6", title: "抗压强度", category: 3, type: 2, code: "cell_49" },
  cell_56: { resultValue: "", key: "kyqd28_1", title: "抗压强度", category: 3, type: 2, code: "cell_56" },
  cell_57: { resultValue: "", key: "kyqd28_2", title: "抗压强度", category: 3, type: 2, code: "cell_57" },
  cell_58: { resultValue: "", key: "kyqd28_3", title: "抗压强度", category: 3, type: 2, code: "cell_58" },
  cell_59: { resultValue: "", key: "kyqd28_4", title: "抗压强度", category: 3, type: 2, code: "cell_59" },
  cell_60: { resultValue: "", key: "kyqd28_5", title: "抗压强度", category: 3, type: 2, code: "cell_60" },
  cell_61: { resultValue: "", key: "kyqd28_6", title: "抗压强度", category: 3, type: 2, code: "cell_61" },
  // 以下为计算属性
  //todo 这里重复
  // cell_27:{resultValue: '', key: 'bzcd', title: '标准稠度', category: 4, type: 2, code: 'cell_27'},
  //todo 这里重复
  // cell_28:{resultValue: '', key: 'cnsj', title: '初凝时间', category: 1, type: 2, code: 'cell_28', require: true},
  //todo 这里重复
  // cell_29:{resultValue: '', key: 'znsj', title: '终凝时间', category: 1, type: 2, code: 'cell_29', require: true},
  cell_42: { resultValue: "", key: "kzqd3", title: "抗折强度3天平均值", category: 4, type: 2, code: "cell_42" },
  cell_43: { resultValue: "", key: "kzqd28", title: "抗折强度28天平均值", category: 4, type: 2, code: "cell_43" },
  cell_50: { resultValue: "", key: "kyqd3", title: "抗压强度3天平均值", category: 1, type: 2, code: "cell_50", require: true, clsObj: { bg1: true } },
  cell_51: { resultValue: "", key: "kyqd28", title: "抗压强度28天平均值", category: 1, type: 2, code: "cell_51", require: true, clsObj: { bg1: true } },
  cell_37: { resultValue: "", key: "wjjsyxpd", title: "外加剂适用性判断", category: 4, type: 2, code: "cell_37" },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  watch: {
    saveData(val) {
      if (val.cell_30.resultValue || val.cell_52.resultValue) {
        this.formData["cell_30"].resultValue = JSON.parse(JSON.stringify(val.cell_30.resultValue));
        this.formData["cell_52"].resultValue = JSON.parse(JSON.stringify(val.cell_52.resultValue));
      }
    },
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        } else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        // console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }
    if (!this.formData.cell_52.options) {
      this.formData.cell_52.options = [
        { id: 0, label: "试饼法" },
        { id: 1, label: "雷氏夹法" },
      ];
    }
    if (!this.formData.cell_30.options) {
      this.formData.cell_30.options = [
        { id: 0, label: "合格" },
        { id: 1, label: "不合格" },
      ];
    }
    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      console.log("1231231");
      let val = "";
      // 标准稠度
      if (this.hasValues([24, 26])) {
        val = Math.round((this.getFieldVal(26) / this.getFieldVal(24)) * 100);
      }
      this.setFieldVal(27, val);
      // 计算初凝时间和终凝时间
      this.calcTime(20, 21, 28);
      this.calcTime(20, 22, 29);

      val = "";
      if (this.hasValues([34, 35, 36])) {
        if (this.getFieldVal(34) > 170 && this.getFieldVal(36) >= this.getFieldVal(35)) {
          val = "是";
        } else {
          val = "否";
        }
      }
      this.setFieldVal(37, val);

      // 计算平均值
      this.calcAverage2([39, 40, 41], 42);
      this.calcAverage2([44, 45, 46, 47, 48, 49], 50);
      this.calcAverage2([53, 54, 55], 43);
      this.calcAverage2([56, 57, 58, 59, 60, 61], 51);
      this.getMathDeic(39);
      this.getMathDeic(40);
      this.getMathDeic(41);
      this.getMathDeic(44);
      this.getMathDeic(45);
      this.getMathDeic(46);
      this.getMathDeic(47);
      this.getMathDeic(48);
      this.getMathDeic(49);
      this.getMathDeic(53);
      this.getMathDeic(54);
      this.getMathDeic(55);
      this.getMathDeic(56);
      this.getMathDeic(57);
      this.getMathDeic(58);
      this.getMathDeic(59);
      this.getMathDeic(60);
      this.getMathDeic(61);
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算堆积密度值
    calcTime(x, y, z) {
      let res = "";
      if (this.hasValues([x, y])) {
        let v1 = this.getFieldVal(x, true);
        let v2 = this.getFieldVal(y, true);
        console.log(v1, v2);
        res = (new Date(v2).getTime() - new Date(v1).getTime()) / 1000 / 60;
        res = Math.round(res);
      } else {
        console.log(112312312);
      }
      this.setFieldVal(z, res);
    },
    // 计算平均值
    calcAverage(arr, z) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(1);
      }
      this.setFieldVal(z, res);
    },
    calcAverage2(arr, z) {
      let res = "";
      let newArr = arr;
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(1);
      }
      if (res) {
        let newArr2 = this.absMax(res, newArr);
        if (this.hasValues(newArr2)) {
          let sum2 = 0;
          for (let key in newArr2) {
            sum2 = sum2 + this.getFieldVal(newArr2[key]);
          }
          res = (sum2 / newArr2.length).toFixed(1);
          if (res) {
            let newArr3 = newArr2.filter(item => Math.abs(this.getFieldVal(item) - res) <= res * 0.1);
            if (!newArr3 || newArr3.length < arr.length - 1 || newArr3 == []) {
              res = -1;
              this.setFieldVal(z, res);
            } else {
              this.setFieldVal(z, res);
            }
          }
        }
      }
    },
    // 取出和平均值差最大的数
    absMax(res, arr) {
      let newArr = [];
      var flag = false;
      arr.forEach(e => {
        newArr.push(Math.abs(res - this.getFieldVal(e)));
      });
      let AS = newArr.sort((a, b) => a - b);
      let maxN = AS[arr.length - 1];

      // return arr.filter(item => Math.abs(res - this.getFieldVal(item)) != maxN);
      arr.forEach((item, index) => {
        if (Math.abs(res - this.getFieldVal(item)) == maxN) {
          if (!flag) {
            return arr.splice(index, 1);
          }
          flag = true;
        }
      });

      return arr;
    },
    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      for (let key in this.formData) {
        if (key.indexOf(curKey) >= 0) {
          config.form[key] = this.formData[key];
        }
      }
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      switch (this.curKey) {
        case "cell_32_":
          if (this.hasValues(form, ["32_p01", "32_p02", "32_p03"])) {
            res = (((this.getFieldVal("32_p03", false, form) - this.getFieldVal("32_p01", false, form)) / this.getFieldVal("32_p02", false, form)) * 1).toFixed(2);
          }
          this.setFieldVal("32_p04", res);
          // this.setFieldVal(32, res)
          break;
        case "cell_33_":
          if (this.hasValues(form, ["33_p01", "33_p02", "33_p03"])) {
            res = (((this.getFieldVal("33_p01", false, form) + this.getFieldVal("33_p02", false, form) - this.getFieldVal("33_p03", false, form)) / this.getFieldVal("33_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("33_p04", res);
          // this.setFieldVal(33, res)
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
    // 取一位小数
    getMathDeic(val) {
      this.$nextTick(() => {
        return (this.formData["cell_" + val].resultValue * 1).toFixed(1);
      });
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
